// set these to automatically configure certain defaults
module.exports = {
  api_port: 5010,
  dev_port: 8010,
  project_title: 'Zia Mapper',
  existing_url: ''
}
